
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 2.5C4.06728 2.5 2.5 4.06728 2.5 6V15.004C2.5 16.9347 4.06528 18.5 5.996 18.5H15.004C16.9349 18.5 18.5 16.9346 18.5 15.005V5.996C18.5 4.06528 16.9347 2.5 15.004 2.5H6ZM6 0.5C2.96272 0.5 0.5 2.96272 0.5 6V15.004C0.5 18.0393 2.96071 20.5 5.996 20.5H15.004C18.0391 20.5 20.5 18.0394 20.5 15.005V5.996C20.5 2.96071 18.0393 0.5 15.004 0.5H6Z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.6 11.4C8.6 10.8477 9.04772 10.4 9.6 10.4H15C15.5523 10.4 16 10.8477 16 11.4C16 11.9523 15.5523 12.4 15 12.4H9.6C9.04772 12.4 8.6 11.9523 8.6 11.4Z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.4 9.555C10.4 7.53672 12.0367 5.9 14.055 5.9H15C15.5523 5.9 16 6.34771 16 6.9C16 7.45228 15.5523 7.9 15 7.9H14.055C13.1413 7.9 12.4 8.64128 12.4 9.555V19.5C12.4 20.0523 11.9523 20.5 11.4 20.5C10.8477 20.5 10.4 20.0523 10.4 19.5V9.555Z","fill":"currentColor"}})])
          )
        }
      }
    